import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { changePasswordAPI, findUsernameAPI } from "../../../api/index";
import "./FindPasswordMobilePage.css";

const MODE_USERNAME = "username";
const MODE_PASSWORD = "password";

const FindPasswordMobilePage = () => {
  const navigate = useNavigate();
  const [mode, setMode] = useState(MODE_PASSWORD);
  const [formData, setFormData] = useState({
    username: "",
    name: "",
    phone: "",
    email: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [foundUsername, setFoundUsername] = useState("");

  const resetForm = () => {
    setMode(MODE_PASSWORD);
    setFormData({
      username: "",
      name: "",
      phone: "",
      email: "",
      newPassword: "",
      confirmPassword: "",
    });
    setErrors({});
    setIsLoading(false);
    setIsSubmitted(false);
    setFoundUsername("");
  };

  const handleClose = () => {
    resetForm();
    navigate("/login");
  };

  const setRecoveryMode = (next) => {
    setMode(next);
    setErrors({});
    setIsSubmitted(false);
    setFoundUsername("");
    setIsLoading(false);
  };

  const formatPhoneNumber = (value) => {
    const numbers = value.replace(/[^0-9]/g, "");
    if (numbers.length <= 3) {
      return numbers;
    } else if (numbers.length <= 7) {
      return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
    } else {
      return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(
        7,
        11
      )}`;
    }
  };

  const handleInputChange = (field, value) => {
    let processedValue = value;
    if (field === "phone") {
      processedValue = formatPhoneNumber(value);
    } else {
      processedValue = value;
    }

    setFormData((prev) => ({
      ...prev,
      [field]: processedValue,
    }));

    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  const handleBlur = (field) => {
    if (field === "phone") {
      return;
    }
    const trimmedValue = formData[field].trim();
    setFormData((prev) => ({
      ...prev,
      [field]: trimmedValue,
    }));
  };

  const validateFindUsername = () => {
    const newErrors = {};
    const trimmedData = {
      name: formData.name.trim(),
      phone: formData.phone.replace(/[^0-9]/g, ""),
      email: formData.email.trim(),
    };

    if (!trimmedData.name) {
      newErrors.name = "이름을 입력해주세요";
    }

    if (!trimmedData.phone) {
      newErrors.phone = "휴대폰번호를 입력해주세요";
    } else if (trimmedData.phone.length < 10) {
      newErrors.phone = "올바른 휴대폰번호를 입력해주세요";
    } else if (!/^01[0-9]/.test(trimmedData.phone)) {
      newErrors.phone = "010, 011, 012, 019로 시작하는 번호를 입력해주세요";
    }

    if (!trimmedData.email) {
      newErrors.email = "이메일을 입력해주세요";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedData.email)) {
      newErrors.email = "올바른 이메일 형식을 입력해주세요";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateForm = () => {
    const newErrors = {};
    const trimmedData = {
      username: formData.username.trim(),
      name: formData.name.trim(),
      phone: formData.phone.replace(/[^0-9]/g, ""),
      email: formData.email.trim(),
      newPassword: formData.newPassword,
      confirmPassword: formData.confirmPassword,
    };

    if (!trimmedData.username) {
      newErrors.username = "아이디를 입력해주세요";
    }

    if (!trimmedData.name) {
      newErrors.name = "이름을 입력해주세요";
    }

    if (!trimmedData.phone) {
      newErrors.phone = "휴대폰번호를 입력해주세요";
    } else if (trimmedData.phone.length < 10) {
      newErrors.phone = "올바른 휴대폰번호를 입력해주세요";
    } else if (!/^01[0-9]/.test(trimmedData.phone)) {
      newErrors.phone = "010, 011, 012, 019로 시작하는 번호를 입력해주세요";
    }

    if (!trimmedData.email) {
      newErrors.email = "이메일을 입력해주세요";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedData.email)) {
      newErrors.email = "올바른 이메일 형식을 입력해주세요";
    }

    if (!trimmedData.newPassword) {
      newErrors.newPassword = "새 비밀번호를 입력해주세요";
    } else if (trimmedData.newPassword.length < 6) {
      newErrors.newPassword = "비밀번호는 6자 이상이어야 합니다";
    }

    if (trimmedData.newPassword !== trimmedData.confirmPassword) {
      newErrors.confirmPassword = "비밀번호를 다시 입력해주세요";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFindUsernameSubmit = async (e) => {
    e.preventDefault();
    if (!validateFindUsername()) {
      return;
    }

    setIsLoading(true);
    try {
      const res = await findUsernameAPI({
        name: formData.name.trim(),
        phone: formData.phone.replace(/[^0-9]/g, ""),
        email: formData.email.trim(),
      });

      if (res.ok && res.username) {
        setFoundUsername(res.username);
      } else {
        alert(res.message || "아이디를 찾을 수 없습니다.");
      }
    } catch (error) {
      console.error("아이디 찾기 오류:", error);
      alert("아이디 찾기 중 오류가 발생했습니다.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }

    setIsLoading(true);
    try {
      const apiData = {
        username: formData.username.trim(),
        name: formData.name.trim(),
        phone: formData.phone.replace(/[^0-9]/g, ""),
        new_password: formData.newPassword,
      };

      const result = await changePasswordAPI(apiData);
      if (result === "" || result === "비밀번호가 변경되었습니다.") {
        setIsSubmitted(true);
      } else {
        alert(`비밀번호 변경 실패: ${result}`);
      }
    } catch (error) {
      console.error("비밀번호 변경 오류:", error);
      alert("비밀번호 변경 중 오류가 발생했습니다.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="find-password-mobile-page-root">
      <div className="find-password-mobile-header">
        <button
          className="find-password-mobile-back-btn"
          onClick={handleClose}
        >
          <svg
            className="find-password-mobile-back-icon"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 18L9 12L15 6"
              stroke="#B4B4B4"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <div className="find-password-mobile-header-title">
          아이디/비밀번호 찾기
        </div>
        <div className="find-password-mobile-header-spacer"></div>
      </div>

      <div className="find-password-mobile-content">
        {!foundUsername && !isSubmitted && (
          <>
            <p className="find-password-mobile-tabs-hint">
              찾기 유형을 선택해주세요.
            </p>
            <div
              className="find-password-mobile-tabs"
              role="tablist"
              aria-label="아이디 또는 비밀번호 찾기"
            >
              <button
                type="button"
                role="tab"
                aria-selected={mode === MODE_USERNAME}
                className={`find-password-mobile-tab ${
                  mode === MODE_USERNAME ? "active" : ""
                }`}
                onClick={() => setRecoveryMode(MODE_USERNAME)}
              >
                아이디 찾기
              </button>
              <button
                type="button"
                role="tab"
                aria-selected={mode === MODE_PASSWORD}
                className={`find-password-mobile-tab ${
                  mode === MODE_PASSWORD ? "active" : ""
                }`}
                onClick={() => setRecoveryMode(MODE_PASSWORD)}
              >
                비밀번호 찾기
              </button>
            </div>
          </>
        )}

        {foundUsername ? (
          <div className="find-password-mobile-success-message">
            <div className="find-password-mobile-success-icon">✓</div>
            <h3>아이디 확인</h3>
            <p className="find-password-mobile-found-wrap">
              회원님의 아이디는{" "}
              <strong className="find-password-mobile-found-id">
                {foundUsername}
              </strong>
              입니다.
            </p>
            <button
              type="button"
              className="find-password-mobile-submit-btn"
              onClick={handleClose}
            >
              확인
            </button>
          </div>
        ) : !isSubmitted ? (
          mode === MODE_USERNAME ? (
            <form
              className="find-password-mobile-form"
              onSubmit={handleFindUsernameSubmit}
            >
              <p className="find-password-mobile-description find-password-mobile-description--wrap">
                가입 시 등록한 이름, 휴대폰 번호, 이메일을 입력해주세요.
              </p>

              <div className="find-password-mobile-form-fields">
                <div className="find-password-mobile-field">
                  <div className="find-password-mobile-label">이름</div>
                  <div
                    className={`find-password-mobile-input-wrapper ${
                      formData.name && formData.name.trim() ? "has-value" : ""
                    }`}
                  >
                    <input
                      type="text"
                      value={formData.name}
                      onChange={(e) =>
                        handleInputChange("name", e.target.value)
                      }
                      onBlur={() => handleBlur("name")}
                      placeholder="이름을 입력해주세요"
                      className="find-password-mobile-input"
                    />
                  </div>
                  {errors.name && (
                    <div className="find-password-mobile-error">
                      {errors.name}
                    </div>
                  )}
                </div>

                <div className="find-password-mobile-field">
                  <div className="find-password-mobile-label">휴대폰번호</div>
                  <div
                    className={`find-password-mobile-input-wrapper ${
                      formData.phone && formData.phone.trim() ? "has-value" : ""
                    }`}
                  >
                    <input
                      type="text"
                      value={formData.phone}
                      onChange={(e) =>
                        handleInputChange("phone", e.target.value)
                      }
                      placeholder="010-1234-5678"
                      className="find-password-mobile-input"
                      maxLength={13}
                    />
                  </div>
                  {errors.phone && (
                    <div className="find-password-mobile-error">
                      {errors.phone}
                    </div>
                  )}
                </div>

                <div className="find-password-mobile-field">
                  <div className="find-password-mobile-label">E-mail</div>
                  <div
                    className={`find-password-mobile-input-wrapper ${
                      formData.email && formData.email.trim() ? "has-value" : ""
                    }`}
                  >
                    <input
                      type="email"
                      value={formData.email}
                      onChange={(e) =>
                        handleInputChange("email", e.target.value)
                      }
                      onBlur={() => handleBlur("email")}
                      placeholder="이메일을 입력해주세요"
                      className="find-password-mobile-input"
                    />
                  </div>
                  {errors.email && (
                    <div className="find-password-mobile-error">
                      {errors.email}
                    </div>
                  )}
                </div>
              </div>

              <div className="find-password-mobile-buttons">
                <button
                  type="submit"
                  className="find-password-mobile-submit-btn"
                  disabled={isLoading}
                >
                  {isLoading ? "확인 중..." : "아이디 찾기"}
                </button>
                <button
                  type="button"
                  className="find-password-mobile-cancel-btn"
                  onClick={handleClose}
                >
                  취소
                </button>
              </div>
            </form>
          ) : (
            <form
              className="find-password-mobile-form"
              onSubmit={handleSubmit}
            >
              <p className="find-password-mobile-description find-password-mobile-description--wrap">
                가입 시 등록한 정보를 입력하고 새로운 비밀번호를 설정해주세요.
              </p>

              <div className="find-password-mobile-form-fields">
                <div className="find-password-mobile-field">
                  <div className="find-password-mobile-label">아이디</div>
                  <div
                    className={`find-password-mobile-input-wrapper ${
                      formData.username && formData.username.trim()
                        ? "has-value"
                        : ""
                    }`}
                  >
                    <input
                      type="text"
                      value={formData.username}
                      onChange={(e) =>
                        handleInputChange("username", e.target.value)
                      }
                      onBlur={() => handleBlur("username")}
                      placeholder="아이디를 입력해주세요"
                      className="find-password-mobile-input"
                    />
                  </div>
                  {errors.username && (
                    <div className="find-password-mobile-error">
                      {errors.username}
                    </div>
                  )}
                </div>

                <div className="find-password-mobile-field">
                  <div className="find-password-mobile-label">이름</div>
                  <div
                    className={`find-password-mobile-input-wrapper ${
                      formData.name && formData.name.trim() ? "has-value" : ""
                    }`}
                  >
                    <input
                      type="text"
                      value={formData.name}
                      onChange={(e) =>
                        handleInputChange("name", e.target.value)
                      }
                      onBlur={() => handleBlur("name")}
                      placeholder="이름을 입력해주세요"
                      className="find-password-mobile-input"
                    />
                  </div>
                  {errors.name && (
                    <div className="find-password-mobile-error">
                      {errors.name}
                    </div>
                  )}
                </div>

                <div className="find-password-mobile-field">
                  <div className="find-password-mobile-label">휴대폰번호</div>
                  <div
                    className={`find-password-mobile-input-wrapper ${
                      formData.phone && formData.phone.trim() ? "has-value" : ""
                    }`}
                  >
                    <input
                      type="text"
                      value={formData.phone}
                      onChange={(e) =>
                        handleInputChange("phone", e.target.value)
                      }
                      placeholder="010-1234-5678"
                      className="find-password-mobile-input"
                      maxLength={13}
                    />
                  </div>
                  {errors.phone && (
                    <div className="find-password-mobile-error">
                      {errors.phone}
                    </div>
                  )}
                </div>

                <div className="find-password-mobile-field">
                  <div className="find-password-mobile-label">E-mail</div>
                  <div
                    className={`find-password-mobile-input-wrapper ${
                      formData.email && formData.email.trim() ? "has-value" : ""
                    }`}
                  >
                    <input
                      type="email"
                      value={formData.email}
                      onChange={(e) =>
                        handleInputChange("email", e.target.value)
                      }
                      onBlur={() => handleBlur("email")}
                      placeholder="이메일을 입력해주세요"
                      className="find-password-mobile-input"
                    />
                  </div>
                  {errors.email && (
                    <div className="find-password-mobile-error">
                      {errors.email}
                    </div>
                  )}
                </div>

                <div className="find-password-mobile-field">
                  <div className="find-password-mobile-label">새 비밀번호</div>
                  <div
                    className={`find-password-mobile-input-wrapper ${
                      formData.newPassword && formData.newPassword.trim()
                        ? "has-value"
                        : ""
                    }`}
                  >
                    <input
                      type="password"
                      value={formData.newPassword}
                      onChange={(e) =>
                        handleInputChange("newPassword", e.target.value)
                      }
                      placeholder="새 비밀번호를 입력해주세요"
                      className="find-password-mobile-input"
                    />
                  </div>
                  {errors.newPassword && (
                    <div className="find-password-mobile-error">
                      {errors.newPassword}
                    </div>
                  )}
                </div>

                <div className="find-password-mobile-field">
                  <div className="find-password-mobile-label">
                    새 비밀번호 확인
                  </div>
                  <div
                    className={`find-password-mobile-input-wrapper ${
                      formData.confirmPassword &&
                      formData.confirmPassword.trim()
                        ? "has-value"
                        : ""
                    }`}
                  >
                    <input
                      type="password"
                      value={formData.confirmPassword}
                      onChange={(e) =>
                        handleInputChange("confirmPassword", e.target.value)
                      }
                      placeholder="새 비밀번호를 다시 입력해주세요"
                      className="find-password-mobile-input"
                    />
                  </div>
                  {errors.confirmPassword && (
                    <div className="find-password-mobile-error">
                      {errors.confirmPassword}
                    </div>
                  )}
                </div>
              </div>

              <div className="find-password-mobile-buttons">
                <button
                  type="submit"
                  className="find-password-mobile-submit-btn"
                  disabled={isLoading}
                >
                  {isLoading ? "변경 중..." : "변경하기"}
                </button>
                <button
                  type="button"
                  className="find-password-mobile-cancel-btn"
                  onClick={handleClose}
                >
                  취소
                </button>
              </div>
            </form>
          )
        ) : (
          <div className="find-password-mobile-success-message">
            <div className="find-password-mobile-success-icon">✓</div>
            <h3>비밀번호가 변경되었습니다</h3>
            <p>
              비밀번호가 성공적으로 변경되었습니다.
              <br />
              새로운 비밀번호로 로그인해주세요.
            </p>
            <button
              type="button"
              className="find-password-mobile-submit-btn"
              onClick={handleClose}
            >
              확인
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default FindPasswordMobilePage;
